import { render, staticRenderFns } from "./tarihimbugundensonra.vue?vue&type=template&id=34d0f74b&"
import script from "./tarihimbugundensonra.vue?vue&type=script&lang=js&"
export * from "./tarihimbugundensonra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports